"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailsHeaderSection = void 0;
const React = require("react");
const react_1 = require("react");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const OrderTypeContext_1 = require("../../../contexts/OrderTypeContext");
const CircularIcon_1 = require("../../../../../../components/base/atoms/CircularIcon");
const constants_1 = require("../../../../../../helpers/constants");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const ChangeLocationConfirmModal_1 = require("../../../modals/ChangeLocationConfirmModal");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const retailCustomerAddressText_1 = require("../../../helpers/retailCustomerAddressText");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "OrderDetailsHeaderSection");
const OrderDetailsHeaderSection = ({}) => {
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { orderType } = (0, react_1.useContext)(OrderTypeContext_1.OrderTypeContext);
    const { temporaryAddress, requestedReadyTime } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const [changeLocationConfirmModal, showChangeLocationConfirmModal] = (0, react_1.useState)(false);
    const requestedReadyTimeLabel = (0, useRetailLocationAvailability_1.useRequestedReadyTimeLabel)(retailLocation, requestedReadyTime, constants_1.humanTimeFormat);
    const addressText = (0, retailCustomerAddressText_1.retailCustomerAddressText)(temporaryAddress, orderType);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("restaurant") }, !!retailLocation ? retailLocation.title : "Menu"),
        React.createElement("div", { className: css("sub") },
            React.createElement(CircularIcon_1.CircularIcon, { name: "chevron-left", className: css("sub_backIcon"), size: standardSizes_1.TStandardSizes.Small, onClick: () => {
                    showChangeLocationConfirmModal(true);
                } }),
            React.createElement("div", { className: css("sub_details") },
                React.createElement("div", { className: css("sub_details_orderType") }, !!orderType ? `${orderType}` : ""),
                React.createElement("div", null,
                    addressText && `${addressText} - `,
                    requestedReadyTimeLabel))),
        React.createElement(ChangeLocationConfirmModal_1.ChangeLocationConfirmModal, { show: changeLocationConfirmModal, dismiss: () => showChangeLocationConfirmModal(false) })));
};
exports.OrderDetailsHeaderSection = OrderDetailsHeaderSection;
//# sourceMappingURL=index.js.map